import { render, staticRenderFns } from "./FaqListTreatment.vue?vue&type=template&id=1d60b2a1&scoped=true&"
import script from "./FaqListTreatment.vue?vue&type=script&lang=js&"
export * from "./FaqListTreatment.vue?vue&type=script&lang=js&"
import style0 from "./FaqListTreatment.vue?vue&type=style&index=0&id=1d60b2a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d60b2a1",
  null
  
)

export default component.exports